module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.6d943d74.jpg";